<qai-inner-wrap>
  <div class="users-tab" *ngIf="isTranslationLoaded">
    <div class="header-row">
      <div>
        <span class="users-label">{{
          "reportingV2.USER_LABEL" | transloco
        }}</span>
        <div>
          <span class="users-count">
            {{ filteredData.length }}
          </span>
          <span class="users-count-label">{{
            "reportingV2.TOTAL_USERS_LABEL" | transloco
          }}</span>
        </div>
      </div>

      <div class="search-export-group">
        <qai-field [label]="''">
          <qai-icon kind="search" qaiSlot="startIcon" />
          <input
            qai-input
            type="text"
            placeholder="{{ 'reportingV2.SEARCH_FOR_A_USER_LABEL' | transloco }}"
            [value]="searchTerm"
            (input)="onSearchChange($event)"
          />
        </qai-field>

        <button class="download-btn" (click)="onDownloadClick()">
          <qai-icon [kind]="'download'" [size]="'20px'"></qai-icon>
        </button>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <qai-loading size="medium"></qai-loading>
    </div>

    <div class="table-wrapper">
      <qai-table
        *ngIf="!isLoading"
        [headers]="headers"
        [data]="filteredData"
        [currentPage]="currentPage"
        (pageChanged)="pageChanged($event)"
        (sortChanged)="onSortChanged($event)"
        (rowClick)="onTableRowClick($event)"
        [noDataMessage]="'reportingV2.NO_USERS_FOUND_LABEL' | transloco"
        [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco"
        [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"
        [isTooltipLoading]="isTooltipLoading"
        (tooltipDataRequested)="onTooltipDataRequested($event)"
      ></qai-table>
    </div>
  </div>
</qai-inner-wrap>
